<div class="card shadow login-card m-auto" [formGroup]="parentForm">
  <div class="card-body py-5">
    <div class="col d-flex justify-content-end">
      <div class="w-75 d-flex flex-column">
        <h1 class="card-title" id="card-title">Sign Up</h1>

        <div class="flex-row d-flex" style="flex-basis: 60%">
          <app-dynamic-form
            class="w-50"
            [jsonFormData]="checkEmailAddressField"
            [parentForm]="parentForm"
            [controlName]="'checkEmailAddress'"
            (isdynamicFormValid)="enableContinueButton($event)"
            (isEnterKeyPress)="isEnterKeyPress($event)"
          ></app-dynamic-form>

          <div class="form-group col inlineBtnwithoutLabel">
            <button
              class="btn btn-primary"
              (click)="redirectTid()"
              [disabled]="!isFormValid"
              type="button"
            >
              <app-loading-spinner
                [loading]="isloading"
                *ngIf="isloading"
              ></app-loading-spinner>
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div></div>
</div>
